import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {BillingTransactionModel} from "@services/back-office/model/billingTransactionModel";
import {PaginationModel} from "@shared/models/pagination.model";
import {BillingTransactionSearchModel} from "@services/back-office/model/billingTransactionSearchModel";
import {ConfigService} from "@config/config.service";
import {PaymentsActions, PaymentsActionTypes} from "@billing/ngrx/actions/payments.actions";

export const adapter: EntityAdapter<BillingTransactionModel> = createEntityAdapter<BillingTransactionModel>();

export interface State extends EntityState<BillingTransactionModel> {
    loading: boolean,
    pagination: PaginationModel,
    filter: BillingTransactionSearchModel
}

export const initialState: State = adapter.getInitialState({
    loading: false,
    pagination: {
        first: true,
        last: false,
        number: 0,
        numberOfElements: 0,
        size: new ConfigService().paginationConfig.pageSize,
        totalElements: 0,
    },
    filter: {}
});

export function reducer(state = initialState, action: PaymentsActions): State {
    switch (action.type) {

        case PaymentsActionTypes.LoadPayments:
            return {...state, loading: !action.payload?.dontShowLoading};

        case PaymentsActionTypes.LoadPaymentsSuccess:
            return adapter.setAll(action.payload.content!, {
                ...state,
                loading: false,
                pagination: {
                    size: action.payload.size,
                    last: action.payload.last,
                    totalElements: action.payload.totalElements,
                    numberOfElements: action.payload.numberOfElements,
                    first: action.payload.first,
                    number: action.payload.number,
                }
            });

        case PaymentsActionTypes.LoadPaymentsFailure:
            return {...state, loading: false};

        case PaymentsActionTypes.EditPayment:
            return {...state};

        case PaymentsActionTypes.EditPaymentSuccess:
            return adapter.updateOne({id: action.payload.id!, changes: action.payload}, {...state});

        case PaymentsActionTypes.ChangePage:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    number: action.payload.number,
                    size: action.payload.size
                }
            };

        case PaymentsActionTypes.DeletePaymentSuccess:
            return adapter.removeOne(action.payload, {
                ...state,
                pagination: {
                    ...state.pagination,
                    numberOfElements: state.pagination.numberOfElements !== 0 ? state.pagination.numberOfElements! - 1 : 0
                }
            });

        case PaymentsActionTypes.SetInitialPagination:
            return {...state, pagination: initialState.pagination};

        case PaymentsActionTypes.SetFilter:
            return {...state, filter: action.payload};

        case PaymentsActionTypes.ClearFilter:
            return {...initialState};

        default:
            return state;
    }
}

export const {
    selectIds: selectPaymentsIds,
    selectAll: selectAllPayments
} = adapter.getSelectors();
